export default {
  'error.title': 'Oops!',
  'error.defaultError': 'Hiện không thể thực hiện được, vui lòng thử lại sau',
  'error.networkError': 'Không thể kết nối tới máy chủ',
  'error.notFoundAPI': 'Không tìm thấy query',
  'error.StoreItemLimitError': 'Phần quà này đã hết',
  'ff.error.loadFailed': 'Không thể tải dữ liệu'
}